module.exports = __webpack_public_path__ + "static/img/spin.ade9202.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/spin.gif
// module id = sC4l
// module chunks = 1